import CoreBase from '../../services/engines/CoreBase';
import componentNotifier from '../../services/wss/ComponentNotifier';
import { EngineNames } from '../../services/wss/events/EngineNames';
import prioUpdater from './PrioUpdater';

const _name = EngineNames.DeleteConfirmEngine;

/**
 * DeleteConfirmEngine — generic delete-confirmation flow for any journal entry.
 * Caller only calls request(entry) — no callback, no per-engine wiring needed. confirm()
 * always does the same generic soft-delete: prioUpdater.save({...entry, stateId: 999}).
 * The BE broadcasts OnJournalUpdated for that, which every engine already listens to
 * (PageContentSRHandlers) — each engine's own cache syncs itself from that, no extra
 * plumbing needed here.
 *
 * GlobalDeleteConfirmDlg (mounted once, DashboardPage) subscribes and renders the QuestionDlg.
 * Extracted 20260704 — was duplicated ad-hoc per widget (NoteOptionsPanelEngine had its own
 * deleteOpen/closeDelete/confirmDelete baked into per-panel state). See Development.Patterns.
 */
class DeleteConfirmEngine extends CoreBase {
    _name = _name;

    _open = false;
    _entry = null;

    /**
     * Opens the confirm dialog for the given entry.
     * @param {object} entry - full journal entry (rk, title, service, stage, ... — same shape PrioUpdater.save expects)
     */
    request = (entry) => {
        this._open = true;
        this._entry = entry;
        this._notify();
    };

    /** Cancels without deleting. */
    cancel = () => {
        this._open = false;
        this._entry = null;
        this._notify();
    };

    /** Confirms — soft-deletes via PrioUpdater (stateId 999), then closes. */
    confirm = async () => {
        try {
            const entry = this._entry;
            this._open = false;
            this._entry = null;
            this._notify();

            if (!entry) return;
            await prioUpdater.save({ ...entry, stateId: 999 });
        } catch (error) {
            this.logError('confirm', error.message);
        }
    };

    isOpen = () => this._open;
    getEntry = () => this._entry;

    // ─── private ──────────────────────────────────────────

    _notify = () => {
        componentNotifier.notify(_name, 'stateChanged', { open: this._open, entry: this._entry });
    };
}

const deleteConfirmEngine = new DeleteConfirmEngine();
export default deleteConfirmEngine;
